export const StatusMessageConfig = {
  error: {
    status: 'danger',
    message: {
      id: 'NewESignature.ESignatureIntegrationCard.ErrorWithIntegration',
      defaultMessage:
        'We encountered an issue with your company account. Please check your login credentials or contact your admin.',
      description: 'Error message about using the e-signature integration',
    },
  },
  warning: {
    status: 'warning',
    message: {
      id: 'NewESignature.ESignatureIntegrationCard.WarningAboutUsingIntegration',
      defaultMessage:
        'The integration is not currently available. To start using {providerName}, remove the currently active e-signature provider first.',
      description: 'Warning message about using the e-signature integration',
    },
  },
};
